import {
   isInLabelValueArrayAsString,
   isInYesNoOptions,
   isValidDateTimeString,
   isValidPositiveNumber
} from "@utils/validators";
import {
   ACCIDENT_PARTIES_AT_FAULT_OPTIONS,
   ACCIDENT_TYPE_OPTIONS,
   CONVICTION_CODES,
   DRIVING_LICENSE_TYPE_OPTIONS,
   EMPLOYMENT_STATUS_OPTIONS,
   TITLE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {isNotStringOrEmptyString} from "@utils/string";
import {isDateGreaterThenToday} from "@utils/date-time";

export function driverBlockName(index, propName) {
   return `additionalDrivers.${index}.${propName}`;
}

export const accidentBlockName = (index, propName) => {
   return `motorAccidentsList.${index}.${propName}`;
}

export const convictionBlockName = (index, propName) => {
   return `motoringConvictionsList.${index}.${propName}`;
}

export const validateAdditionalDrivers = ({
   data,
   msgList = [],
}) => {
   
   //additionalDrivers
   
   if (!isInLabelValueArrayAsString(data.shouldAddAdditionalDrivers, YES_NO_CHOICE_OPTIONS)) {
      
      msgList.push({
         name: 'shouldAddAdditionalDrivers',
         message: 'Please select if you would like to add additional drivers'
      })
      
   }
   
   if ('Yes' === data.shouldAddAdditionalDrivers) {
      
      if (!Array.isArray(data.additionalDrivers) || data.additionalDrivers.length === 0) {
         msgList.push({
            name: 'additionalDrivers',
            message: 'Please specify one or more additional drivers'
         })
         
         return;
      }
      
      data.additionalDrivers.forEach((driver, driverIndex) => {
         validateSingleDriverInfo(msgList, driver, driverIndex);
      })
      
   }
   
}

const validateSingleDriverInfo = (msgList, driver, driverIndex) => {
   
   if (!isInLabelValueArrayAsString(driver.title, TITLE_OPTIONS)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'title'),
         message: `Please specify the driver's title @ driver form ${driverIndex + 1}`
      })
   }
   
   if (isNotStringOrEmptyString(driver.firstName)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'firstName'),
         message: `Please specify the driver's first name @ driver form ${driverIndex + 1}`
      })
   }
   
   if (isNotStringOrEmptyString(driver.lastName)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'lastName'),
         message: `Please specify the driver's last name @ driver form ${driverIndex + 1}`
      })
   }
   
   if (!isValidDateTimeString(driver.birthDate)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'birthDate'),
         message: `Please specify the driver's birth date @ driver form ${driverIndex + 1}`
      })
   } else if (isDateGreaterThenToday(driver.birthDate)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'birthDate'),
         message: `The driver's birth date cannot be in the future! @ driver form ${driverIndex + 1}`
      })
   }
   
   if (!isInLabelValueArrayAsString(driver.isBornInUK, YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'isBornInUK'),
         message: `Please specify if the driver was born in the UK @ driver form ${driverIndex + 1}`
      })
   }
   
   if ('No' === driver.isBornInUK) {
      
      if (!isValidDateTimeString(driver.yearObtainingUKResidency)) {
         msgList.push({
            name: driverBlockName(driverIndex, 'yearObtainingUKResidency'),
            message: `Please specify the year the driver got UK residency @ driver form ${driverIndex + 1}`
         })
      } else if (isDateGreaterThenToday(driver.yearObtainingUKResidency)) {
         msgList.push({
            name: driverBlockName(driverIndex, 'yearObtainingUKResidency'),
            message: `The driver's year of obtaining UK residency cannot be in the future! @ driver form ${driverIndex + 1}`
         })
      }
   }
   
   if (!isInLabelValueArrayAsString(driver.employmentStatus, EMPLOYMENT_STATUS_OPTIONS)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'employmentStatus'),
         message: `Please specify the driver's employment status @ driver form ${driverIndex + 1}`
      })
   }
   
   if (!isInLabelValueArrayAsString(driver.licenseType, DRIVING_LICENSE_TYPE_OPTIONS)) {
      
      msgList.push({
         name: driverBlockName(driverIndex, 'licenseType'),
         message: `Please specify the driver's license type @ driver form ${driverIndex + 1}`
      })
      
   }
   
   if (!isValidDateTimeString(driver.licenseDate)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'licenseDate'),
         message: `Please specify driving license obtaining date @ driver form ${driverIndex + 1}`
      })
   } else if (isDateGreaterThenToday(driver.licenseDate)) {
      
      msgList.push({
         name: driverBlockName(driverIndex, 'licenseDate'),
         message: `Driver's license obtaining date cannot be in the future! @ driver form ${driverIndex + 1}`
      });
      
   }
   
   if(!isInYesNoOptions(driver.wantToAddLicenseNumber)) {
      
      msgList.push({
         name: driverBlockName(driverIndex, 'wantToAddLicenseNumber'),
         message: `${driver.wantToAddLicenseNumber} Please specify if you want to add license number @ driver form ${driverIndex + 1}`
      })
      
   }
   
   if('Yes' === driver.wantToAddLicenseNumber) {
      
      if(isNotStringOrEmptyString(driver.licenseNumber)) {
         msgList.push({
            name: driverBlockName(driverIndex, 'licenseNumber'),
            message: `Please specify the license number @ driver form ${driverIndex + 1}`
         })
      }
   }
   
   if (!isInLabelValueArrayAsString(driver.hasChildren, YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'hasChildren'),
         message: `Please specify if the driver has children @ driver form ${driverIndex + 1}`
      })
   }
   
   if('Yes' === driver.hasChildren) {
      
      if(isNotStringOrEmptyString(driver.numberOfChildren)) {
         msgList.push({
            name: driverBlockName(driverIndex, 'numberOfChildren'),
            message: `Please specify the number of children @ driver form ${driverIndex + 1}`
         })
      } else if(!isValidPositiveNumber(driver.numberOfChildren) || (driver.numberOfChildren <= 0)) {
      
         msgList.push({
            name: driverBlockName(driverIndex, 'numberOfChildren'),
            message: `Number of children must be greater than 0 @ driver form ${driverIndex + 1}`
         })
         
      }
      
   }
   
   if (!isInLabelValueArrayAsString(driver.motorAccidentsOrClaimsIn5Years, YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'motorAccidentsOrClaimsIn5Years'),
         message: `Please specify if the driver has motor accidents or claims in last 5 years @ driver form ${driverIndex + 1}`
      })
   }
   
   if ('Yes' === driver.motorAccidentsOrClaimsIn5Years) {
      
      if (!Array.isArray(driver.motorAccidentsList) || driver.motorAccidentsList.length === 0) {
         
         msgList.push({
            name: driverBlockName(driverIndex, 'motorAccidentsList'),
            message: `Please specify one or more incident record(s) @ driver form ${driverIndex + 1}`
         })
         
      } else {
         
         driver.motorAccidentsList.forEach((accident, accidentIndex) => {
            validateAccident(msgList, accident, accidentIndex, driverIndex);
         })
         
      }
   }
   
   if (!isInLabelValueArrayAsString(driver.motoringConvictionsIn5Years, YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: driverBlockName(driverIndex, 'motoringConvictionsIn5Years'),
         message: `Please specify if the driver has motoring convictions in last 5 years @ driver form ${driverIndex + 1}`
      })
   }
   
   if ('Yes' === driver.motoringConvictionsIn5Years) {
      
      if (!Array.isArray(driver.motoringConvictionsList) || driver.motoringConvictionsList.length === 0) {
         
         msgList.push({
            name: driverBlockName(driverIndex, 'motoringConvictionsList'),
            message: `Please specify one or more conviction record(s) @ driver form ${driverIndex + 1}`
         })
         
      } else {
         
         
         driver.motoringConvictionsList.forEach((conviction, convictionIndex) => {
            validateConviction(msgList, conviction, convictionIndex, driverIndex);
         })
         
      }
   }
}

const validateAccident = (msgList, accident, accidentIndex, driverIndex) => {
   
   /*msgList.push({
      name: 'tt',
      message: JSON.stringify(accident)
   })*/
   
   
   
   if (!isInLabelValueArrayAsString(accident.type, ACCIDENT_TYPE_OPTIONS)) {
      msgList.push({
         name: accidentBlockName(accidentIndex, 'type'),
         message: `Please specify the accident type @ incident form ${accidentIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if (!isValidDateTimeString(accident.date)) {
      msgList.push({
         name: accidentBlockName(accidentIndex, 'date'),
         message: `Please specify the accident date @ incident form ${accidentIndex + 1} - driver form ${driverIndex + 1}`
      })
   } else if (isDateGreaterThenToday(accident.date)) {
      msgList.push({
         name: accidentBlockName(accidentIndex, 'date'),
         message: `The accident date cannot be in the future! @ incident form ${accidentIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if (!isInLabelValueArrayAsString(accident.partyAtFault, ACCIDENT_PARTIES_AT_FAULT_OPTIONS)) {
      msgList.push({
         name: accidentBlockName(accidentIndex, 'partyAtFault'),
         message: `Please specify the party at fault @ incident form ${accidentIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if (!isInLabelValueArrayAsString(accident.wasAccidentSettled, YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: accidentBlockName(accidentIndex, 'wasAccidentSettled'),
         message: `Please specify if the accident has been settled @ incident form ${accidentIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
}

const validateConviction = (msgList, conviction, convictionIndex, driverIndex) => {
   
   /*msgList.push({
      name: 'tt',
      message: JSON.stringify(conviction)
   })*/
   
   if (!isValidDateTimeString(conviction.date)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'date'),
         message: `Please specify the conviction date @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   } else if (isDateGreaterThenToday(conviction.date)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'date'),
         message: `The conviction date cannot be in the future! @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if (!isInLabelValueArrayAsString(conviction.code, CONVICTION_CODES)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'code'),
         message: `Please specify the conviction code @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if('Other' === conviction.code) {
      
      if(isNotStringOrEmptyString(conviction.otherCode)) {
         msgList.push({
            name: convictionBlockName(convictionIndex, 'otherCode'),
            message: `Please specify the other conviction code @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
         })
      }
   }
   
   if (isNotStringOrEmptyString(conviction.points)) {
      
      msgList.push({
         name: convictionBlockName(convictionIndex, 'points'),
         message: `Please specify the conviction points @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
      
   } else if (!isValidPositiveNumber(conviction.points)) {
      
      msgList.push({
         name: convictionBlockName(convictionIndex, 'points'),
         message: `Conviction points must be greater than 0 @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if (isNotStringOrEmptyString(conviction.fines)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'fines'),
         message: `Please specify the conviction fines @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   } else if (!isValidPositiveNumber(conviction.fines, true)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'fines'),
         message: `Conviction fines must be greater than or equal to 0 @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if (isNotStringOrEmptyString(conviction.banLengthInMonths)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'banLengthInMonths'),
         message: `Please specify the conviction ban length in months @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   } else if (!isValidPositiveNumber(conviction.banLengthInMonths, true)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'banLengthInMonths'),
         message: `Conviction ban length in months must be greater than or equal to 0 @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
   if(!isInLabelValueArrayAsString(conviction.wasDriverBreathalysed,YES_NO_CHOICE_OPTIONS)) {
      
      msgList.push({
         name: convictionBlockName(convictionIndex,'wasDriverBreathalysed'),
         message: `Please specify if the driver was breathalysed @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      });
      
   }
   
   if (!isInLabelValueArrayAsString(conviction.wasOffenceAccidentRelated, YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: convictionBlockName(convictionIndex, 'wasOffenceAccidentRelated'),
         message: `Please specify if the offence was accident related @ conviction form ${convictionIndex + 1} - driver form ${driverIndex + 1}`
      })
   }
   
}